<template>
  <div>
    <div class="comingSoon">
      <div class="logo"></div>
      <div class="mainBox"></div>
      <div class="mainContent text-wrap">
        <h2>
          سامانه طرح تقسیم کار ملی ستاد توسعه زیست فناوری به زودی در دسترس خواهد
          بود...
        </h2>
        <br />
        <br />
        <h5>
          ما در حال به‌روزرسانی سامانه هستیم. از صبر و شکیبایی شما سپاسگزاریم.
        </h5>

        <div
          class="counter d-flex flex-row justify-space-between"
          v-if="showCounter"
        >
          <div class="box">
            <p>{{ day }}</p>
            <span>روز</span>
          </div>
          <div class="box">
            <p>{{ hour }}</p>
            <span>ساعت</span>
          </div>
          <div class="box">
            <p>{{ min }}</p>
            <span>دقیقه</span>
          </div>
          <div class="box">
            <p>{{ sec }}</p>
            <span>ثانیه</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      day: null,
      hour: null,
      min: null,
      sec: null,
      showCounter: true,
    };
  },
  methods: {
    GetCount() {
      let dateFuture = new Date(2022, 5, 6, 8, 0, 0);
      let dateNow = new Date();
      //grab current date
      let amount = dateFuture.getTime() - dateNow.getTime();
      //calc milliseconds between dates

      // time is already past
      if (amount < 0) {
        this.showCounter = false;
        this.day = "00";
        this.hour = "00";
        this.min = "00";
        this.sec = "00";
      }
      // date is still good
      else {
        amount = Math.floor(amount / 1000); //kill the "milliseconds" so just this.sec

        this.day = Math.floor(amount / 86400); //this.day
        amount = amount % 86400;
        if (this.day < 10) {
          this.day = "0" + this.day;
        }

        this.hour = Math.floor(amount / 3600); //this.hour
        amount = amount % 3600;
        if (this.hour < 10) {
          this.hour = "0" + this.hour;
        }

        this.min = Math.floor(amount / 60); //minutes
        amount = amount % 60;
        if (this.min < 10) {
          this.min = "0" + this.min;
        }

        this.sec = Math.floor(amount); //seconds
        if (this.sec < 10) {
          this.sec = "0" + this.sec;
        }

        setTimeout(() => {
          this.GetCount();
        }, 1000);
      }
    },
  },
  mounted() {
    this.GetCount();
  },
};
</script>

<style lang="scss">
.comingSoon {
  background-color: #41725f;
  height: 100vh;
  overflow: hidden;
  position: relative;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.68);
  }

  .logo {
    background-image: url("../assets/images/biodc.png");
    background-size: cover;
    min-width: 150px;
    min-height: 45px;
    position: absolute;
    left: 20px;
    top: 20px;
  }

  .mainBox {
    width: 71vw;
    height: 150vh;
    background-color: rgba(0, 0, 0, 0.8);
    transform: rotate(12deg);
    position: absolute;
    top: -140px;
    right: -90px;
  }
  .mainContent {
    color: #fff;
    position: absolute;
    right: 155px;
    top: 50%;
    transform: translate(0, -40%);
    max-width: 44vw;
    h2 {
      font-size: 31px;
    }
    .counter {
      width: 580px;
      padding: 20px;
      margin: 100px auto 0;
      .box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;

        p {
          font-size: 55px;
          background: linear-gradient(
            180deg,
            #172b23 0%,
            #2a4239 35%,
            #456357 100%
          );
          width: 110px;
          height: 100px;
          border-radius: 15px;
          text-align: center;
          padding-top: 10px;
        }
        span {
          font-size: 17px;
        }
      }
    }
  }
}
</style>
